<template>
  <div class="page-wrapper">
    <!-- ============== PC版 ============== -->
    <div class="pc-version">
      <div
        class="user-prize-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="选择状态"
              style="width: 160px"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <!-- 新增用户头像 -->
          <el-table-column label="头像" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.avatar"
                fit="cover"
                style="width:40px;height:40px;border-radius:50%"
                :preview-src-list="[scope.row.avatar]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            label="昵称"
            prop="nickname"
            width="120"
            align="center"
          />
          <el-table-column label="盲盒名称" prop="box_name" min-width="140" />
          <el-table-column
            label="奖品名称"
            prop="box_prize_name"
            min-width="150"
          />

          <!-- 奖品图片 -->
          <el-table-column label="奖品图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.box_prize_image"
                fit="cover"
                style="width: 50px; height: 50px; border-radius: 4px"
                :preview-src-list="[scope.row.box_prize_image]"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            label="奖品等级名"
            prop="level_name"
            width="100"
            align="center"
          />
          <el-table-column
            label="等级数值"
            prop="box_prize_level"
            width="90"
            align="center"
          />
          <el-table-column
            label="价值"
            prop="price"
            width="100"
            align="center"
          />
          <el-table-column
            label="回收价"
            prop="recovery_price"
            width="100"
            align="center"
          />
          <el-table-column label="数量" prop="num" width="80" align="center" />
          <el-table-column label="类型" prop="type" width="80" align="center" />
          <el-table-column label="状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                {{ scope.row.status_name }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-view"
                @click="openDetail(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </div>

    <!-- ============== 移动端 ============== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="选择状态"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-top">
              <div class="label">
                {{ item.box_name }} · {{ item.box_prize_name }}
              </div>
              <el-tag :type="getStatusTagType(item.status)" size="mini">
                {{ item.status_name }}
              </el-tag>
            </div>

            <div style="margin: 10px 0">
              <el-image
                :src="item.box_prize_image"
                fit="cover"
                style="width: 70px; height: 70px; border-radius: 6px"
                :preview-src-list="[item.box_prize_image]"
              ></el-image>
            </div>

            <div class="card-body">
              <!-- 新增头像 -->
              <div style="display:flex;align-items:center;gap:8px">
                <span>头像：</span>
                <el-image
                  :src="item.avatar"
                  style="width:36px;height:36px;border-radius:50%"
                  fit="cover"
                  :preview-src-list="[item.avatar]"
                ></el-image>
              </div>
              <div>
                <span>用户ID：</span>{{ item.user_id }} ({{ item.nickname }})
              </div>
              <div>
                <span>等级：</span>{{ item.level_name }}
                {{ item.box_prize_level }}级
              </div>
              <div><span>价值：</span>{{ item.price }} 元</div>
              <div><span>数量：</span>{{ item.num }}</div>
              <div><span>类型：</span>{{ item.type }}</div>
            </div>

            <div style="text-align: right; margin-top: 10px">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openDetail(item)"
              >
                查看详情
              </el-button>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>

    <!-- ================== PC 端详情弹窗（固定1000px + 表格） ================== -->
    <el-dialog
      v-if="isPC"
      title="奖品详情"
      :visible.sync="pcDetailVisible"
      width="1000px"
      append-to-body
      destroy-on-close
    >
      <div v-loading="detailLoading" element-loading-text="加载中...">
        <el-table
          :data="detailList"
          border
          stripe
          style="width: 100%; min-height: 300px"
        >
          <el-table-column label="ID" prop="id" width="70" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="100"
            align="center"
          />
          <!-- 详情头像 -->
          <el-table-column label="头像" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.avatar"
                style="width:40px;height:40px;border-radius:50%"
                :preview-src-list="[scope.row.avatar]"
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="昵称"
            prop="nickname"
            width="120"
            align="center"
          />
          <el-table-column label="盲盒名称" prop="box_name" min-width="140" />
          <el-table-column
            label="奖品名称"
            prop="box_prize_name"
            min-width="140"
          />
          <el-table-column label="奖品图片" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.box_prize_image"
                style="width: 40px; height: 40px; border-radius: 4px"
                :preview-src-list="[scope.row.box_prize_image]"
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="等级名"
            prop="level_name"
            width="90"
            align="center"
          />
          <el-table-column
            label="等级值"
            prop="box_prize_level"
            width="80"
            align="center"
          />
          <el-table-column
            label="价值"
            prop="price"
            width="90"
            align="center"
          />
          <el-table-column
            label="回收价"
            prop="recovery_price"
            width="90"
            align="center"
          />
          <el-table-column label="数量" prop="num" width="70" align="center" />
          <el-table-column label="类型" prop="type" width="70" align="center" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)" size="mini">
                {{ scope.row.status_name }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            min-width="160"
            align="center"
          />
        </el-table>

        <el-pagination
          v-if="detailTotal > 0"
          @current-change="handleDetailCurrentChange"
          :current-page="detailPage"
          :page-size="detailLimit"
          layout="total, prev, pager, next, jumper"
          :total="detailTotal"
          style="text-align: right; margin-top: 15px"
        ></el-pagination>

        <div
          v-if="!detailList.length && !detailLoading"
          style="text-align: center; padding: 40px; color: #999"
        >
          暂无数据
        </div>
      </div>
    </el-dialog>

    <!-- ================== 移动端详情弹窗（卡片展示） ================== -->
    <el-dialog
      v-else
      title="奖品详情"
      :visible.sync="mobileDetailVisible"
      width="100%"
      append-to-body
      destroy-on-close
    >
      <div v-loading="detailLoading" element-loading-text="加载中...">
        <div class="mobile-detail-list">
          <div
            class="mobile-detail-card"
            v-for="item in detailList"
            :key="item.id"
          >
            <div class="detail-card-top">
              <div>{{ item.box_name }} · {{ item.box_prize_name }}</div>
              <el-tag :type="getStatusTagType(item.status)" size="mini">{{
                item.status_name
              }}</el-tag>
            </div>
            <div style="margin: 10px 0">
              <el-image
                :src="item.box_prize_image"
                style="width: 60px; height: 60px; border-radius: 6px"
                :preview-src-list="[item.box_prize_image]"
                fit="cover"
              />
            </div>
            <div class="detail-card-body">
              <!-- 详情头像 -->
              <div style="display:flex;align-items:center;gap:8px">
                <span>头像：</span>
                <el-image
                  :src="item.avatar"
                  style="width:36px;height:36px;border-radius:50%"
                  fit="cover"
                  :preview-src-list="[item.avatar]"
                ></el-image>
              </div>
              <div>
                <span>用户：</span>{{ item.user_id }} ({{ item.nickname }})
              </div>
              <div>
                <span>等级：</span>{{ item.level_name }}
                {{ item.box_prize_level }}级
              </div>
              <div><span>价值：</span>{{ item.price }} 元</div>
              <div><span>回收价：</span>{{ item.recovery_price }} 元</div>
              <div><span>数量：</span>{{ item.num }}</div>
              <div><span>类型：</span>{{ item.type }}</div>
              <div><span>时间：</span>{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <div
          v-if="!detailList.length && !detailLoading"
          style="text-align: center; padding: 30px; color: #999"
        >
          暂无数据
        </div>

        <el-pagination
          v-if="detailTotal > 0"
          @current-change="handleDetailCurrentChange"
          :current-page="detailPage"
          layout="prev, pager, next, total"
          :total="detailTotal"
          style="text-align: center; margin-top: 15px"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserPrizeList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      statusOptions: [],
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        status: 1,
      },
      searchCollapsed: true,
      isPC: false,

      // 详情共用
      detailLoading: false,
      detailList: [],
      detailPage: 1,
      detailLimit: 10,
      detailTotal: 0,
      currentRow: null,

      // 弹窗分开
      pcDetailVisible: false,
      mobileDetailVisible: false,
    };
  },
  created() {
    this.getList();
    this.checkDevice();
  },
  methods: {
    // 判断设备
    checkDevice() {
      this.isPC = !navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad)/i);
    },

    // 原有列表
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.userPrizeList({
          params: this.searchParams,
        });
        if (res.data.code == "1000") {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.statusOptions = res.data.data.status || [];
        }
      } finally {
        this.loading = false;
      }
    },

    getStatusTagType(status) {
      const map = {
        1: "warning",
        2: "success",
        3: "info",
        4: "primary",
        5: "danger",
        6: "success",
        7: "info",
        8: "primary",
        9: "default",
      };
      return map[status] || "default";
    },

    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, user_id: "", status: "" };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },

    // 打开详情
    openDetail(row) {
      this.currentRow = row;
      this.detailPage = 1;
      this.detailLimit = 10;
      if (this.isPC) {
        this.pcDetailVisible = true;
      } else {
        this.mobileDetailVisible = true;
      }
      this.getDetailList();
    },

    // 获取详情
    async getDetailList() {
      if (!this.currentRow) return;
      this.detailLoading = true;
      try {
        const res = await api.users.userPrizeDetail({
          params: {
            page: this.detailPage,
            page_size: this.detailLimit,
            status: this.currentRow.status,
            user_id: this.currentRow.user_id,
            recovery_price: this.currentRow.recovery_price,
            goods_id: this.currentRow.goods_id,
          },
        });
        if (res.data.code === "1000") {
          this.detailList = res.data.data.data || [];
          this.detailTotal = res.data.data.total;
        }
      } catch (e) {
        this.$message.error("获取详情失败");
      } finally {
        this.detailLoading = false;
      }
    },

    // 详情分页
    handleDetailCurrentChange(val) {
      this.detailPage = val;
      this.getDetailList();
    },
  },
};
</script>

<style scoped>
.user-prize-log-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}

/* 移动端详情卡片样式 */
.mobile-detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-detail-card {
  background: #f9f9f9;
  border-radius: 10px;
  padding: 12px;
}
.detail-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 500;
}
.detail-card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.9;
}
.detail-card-body span {
  color: #333;
  font-weight: 500;
  min-width: 60px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/userPrize.vue